import AppointmentList from "views-interpreters/AppointmentList";
import BillingualRequests from "views-interpreters/BillingualRequests";
import Dashboard from "views-interpreters/Dashboard";
import Payments from "views-interpreters/Payments";
import Profile from "views-interpreters/profile";
import Reports from "views-interpreters/Reports";
import ChangePassword from "views/ChangePassword";
import Translation from "views-interpreters/Translations/Translation";
import TranslationView from "views-interpreters/Translations/TranslationView";


var routesInterpreters = [
  {
    path: "/dashboard",
    title:"Dashboard",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <Dashboard />,
    layout: "/interpreter",
  },
  {
    path: "/appointments",
    title:"Appointments",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <AppointmentList />,
    layout: "/interpreter",
  },
  {
    path: "/billingual-requests",
    title:"Bilingual Requests",
    icon: "/images/file-contract-regular.svg",
    iconActive: "/images/file-contract-solid.svg",
    component: <BillingualRequests />,
    layout: "/interpreter",
  },
  {
    path: "/reports",
    title:"Reports",
    icon: "/images/file-contract-regular.svg",
    iconActive: "/images/file-contract-solid.svg",
    component: <Reports />,
    layout: "/interpreter",
  },
  {
    path: "/translations",
    title:"Translations",
    icon: "/images/meeting-place.png",
    iconActive: "/images/meeting-place-active.png",
    component: <Translation />,
    layout: "/interpreter",
  },
  {
    path: "/translation/view/:id",
    subRoute: true,
    component: <TranslationView />,
    layout: "/interpreter",
  },
  // {
  //   path: "/payments",
  //   title: "Payments",
  //   icon: "/images/admin.png",
  //   iconActive: "/images/admin-active.png",
  //   component:  <Payments/>,
  //   layout: "/interpreter",
  // },
  {
    path: "/profile",
    subRoute: true,
    component:  <Profile/>,
    layout: "/interpreter",
  },
  {
    path: "/change-password",
    subRoute: true,
    component: <ChangePassword />,
    layout: "/interpreter",
  },
];
export default routesInterpreters;
